import { BaseService, HttpClient } from 'core/common/services';
import { Logger } from 'core/common/services/logger/interfaces';
import { convertToBase64 } from 'core/common/utils/convertToBase64';
import { convertToBlob } from 'core/common/utils/convertToBlob';
import { stripBase64Prefix } from 'core/common/utils/stripBase64Prefix';
import { PalmPhoto } from 'core/palmistry/entities';
import { PalmDtoMapper } from 'core/palmistry/mappers';
import { PalmPhotoDTO } from './dto';

export class PalmDetectionService extends BaseService {
  constructor(httpClient: HttpClient, logger: Logger) {
    super(httpClient, logger);
  }

  async detectPalm(image: HTMLCanvasElement): Promise<PalmPhoto> {
    const dtoMapper = new PalmDtoMapper();

    const palmPhoto = new FormData();
    const imageBlob = await convertToBlob(image);

    if (imageBlob) {
      palmPhoto.append('photo', imageBlob, 'image.png');
    }

    const { data } = await this.httpClient.post<PalmPhotoDTO | { error: string }>(
      '/palmistry/detect',
      {
        data: palmPhoto,
        headers: {
          'Content-type': 'multipart/form-data',
        },
      },
    );

    if ('error' in data) {
      const result = await this.detectPalmBase64(image);
      return result;
    }

    return dtoMapper.toEntity(data);
  }

  async detectPalmBase64(image: HTMLCanvasElement): Promise<PalmPhoto> {
    const dtoMapper = new PalmDtoMapper();

    const fileString = convertToBase64(image);

    const file = stripBase64Prefix(fileString);

    const { data } = await this.httpClient.post('/palmistry/detect-base64', {
      data: {
        file,
      },
    });

    return dtoMapper.toEntity(data);
  }

  async uploadPalmPhoto(file: File): Promise<PalmPhoto> {
    const dtoMapper = new PalmDtoMapper();

    const palmPhoto = new FormData();
    palmPhoto.append('photo', file, 'image.png');

    const { data } = await this.httpClient.post<PalmPhotoDTO>('/palmistry/detect', {
      data: palmPhoto,
      headers: {
        'Content-type': 'multipart/form-data',
      },
    });

    if ('error' in data) {
      throw Error('Error occured uploading palm scan');
    }

    return dtoMapper.toEntity(data);
  }
}
